module.exports = __webpack_public_path__ + "img/ads-account-management.384da9bb.png";